module.exports = __webpack_public_path__ + "img/11-oneImg.46fe3bd2.png";